import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { images } from '../data/content';
const highlights = [{
  value: '6',
  label: 'Premium Volumes'
}, {
  value: '35+',
  label: 'Planning Tools'
}, {
  value: '5',
  label: 'Pro Bonuses'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-white" data-id="element-155" data-mp="4jm71qy2f7s5">
      <div className="bg-brand-950 px-4 py-2.5 text-center text-xs font-bold uppercase tracking-wider text-cta sm:text-sm" data-id="element-156" data-mp="12861s1aa6gsn">
        Special launch offer · Only $27 today
      </div>
      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 pb-16 pt-8 md:grid-cols-[1.05fr_1fr] md:gap-12 md:pb-24 md:pt-16" data-id="element-157" data-mp="sai16upzuf2k">
        <div className="text-center md:text-left" data-id="element-158" data-mp="nbyj55eitnfh">
          <p className="inline-block rounded-full bg-brand-100 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider text-brand-700 sm:text-sm" data-id="element-159" data-mp="3d21uq4bdkwqw">
            For Pediatric Occupational Therapists
          </p>
          <p className="mt-5 text-sm font-extrabold uppercase tracking-wider text-brand-600" data-id="element-160" data-mp="3j9kc5f0exnhp">
            Sensory Modulation Treatment Roadmap™
          </p>
          <h1 className="mt-3 text-balance text-[2rem] font-extrabold leading-[1.12] text-brand-950 sm:text-5xl md:text-[3.25rem]" data-id="element-161" data-mp="39acw2k2aneqw">
            Turn Sensory Modulation Assessment Findings Into a Structured Intervention Plan{' '}
            <span className="whitespace-nowrap rounded-lg bg-cta px-2 text-cta-ink" data-id="element-162" data-mp="30hrev8eb9g46">in 20 Minutes</span>
          </h1>
          <p className="mt-4 text-xl font-bold text-brand-700 sm:text-2xl" data-id="element-163" data-mp="359j85qoupzy0">— Without Starting From Scratch</p>

          <div className="mt-8 md:hidden" data-id="element-164" data-mp="2qlepgmpstof8">
            <img src={images.mockup} alt="Sensory Modulation Treatment Roadmap: 6 volumes, toolkit and 5 bonuses" className="mx-auto w-full max-w-md" data-id="element-165" data-mp="2vion2pncd6e5" />
          </div>

          <p className="mt-6 text-lg leading-relaxed text-brand-900/80" data-id="element-166" data-mp="2ll0g91cgo8fm">
            A step-by-step clinical planning framework that helps you organize intervention priorities, select appropriate
            sensory regulation strategies, establish functional goals, and build individualized treatment plans with
            greater clarity.
          </p>

          <dl className="mt-7 grid grid-cols-3 gap-2 sm:gap-3" data-id="element-167" data-mp="i9vqb23hxwks">
            {highlights.map(h => <div key={h.label} className="rounded-2xl bg-brand-50 px-2 py-4 text-center ring-1 ring-brand-100" data-id="element-168" data-mp="dbaq32o8vcwc">
                <dt className="sr-only" data-id="element-169" data-mp="1622idp26vhee">{h.label}</dt>
                <dd data-id="element-170" data-mp="162ccnou9oapw">
                  <span className="block text-3xl font-extrabold text-brand-700 sm:text-4xl" data-id="element-171" data-mp="15zztx9gopwbs">{h.value}</span>
                  <span className="mt-1 block text-xs font-bold leading-tight text-brand-900/75 sm:text-sm" data-id="element-172" data-mp="x14ohzlgsq9j">
                    {h.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="hidden md:block" data-id="element-173" data-mp="3hqagqilkozhv">
          <img src={images.mockup} alt="Sensory Modulation Treatment Roadmap: 6 volumes, toolkit and 5 bonuses" className="w-full" data-id="element-174" data-mp="3htpzpwidasok" />
        </div>

        <div className="md:col-span-2" data-id="element-175" data-mp="218tpdugn58ec">
          <p className="mb-5 text-balance text-center text-base font-semibold text-brand-900/80" data-id="element-176" data-mp="269hcw65nv73t">
            From understanding a child's sensory modulation challenges to organizing a practical, function-focused
            intervention plan.
          </p>
          <CTAButton id="first-cta" label="Get the Complete Sensory Modulation Treatment Roadmap™" data-id="element-177" data-mp="2g1wuh2d1pto6" />
          <p className="mt-4 flex flex-wrap items-center justify-center gap-x-1.5 text-center text-sm font-medium text-brand-900/70" data-id="element-178" data-mp="2l0zyqkl7bvv3">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-179" data-mp="2u03k5v7ucncr" />
            Instant digital access · One-time payment of USD $27 · Lifetime access
          </p>
          <Countdown data-id="element-180" data-mp="uok99b2z950g" />
          <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-brand-900/55" data-id="element-181" data-mp="zlaqi1qiq6ng">
            The 20-minute timeframe refers to completing an initial planning worksheet using existing assessment
            information. It does not represent a complete clinical evaluation, individualized treatment decision, or
            guaranteed clinical outcome.
          </p>
        </div>
      </div>
    </header>;
}